import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  CREATE_POSITION,
  CREATE_ZONE, DELETE_POSITION, DELETE_ZONE,
  LOAD_LIST,
  LOAD_POSITION_BY_CAMERA_LIST,
  LOAD_ZONES_BY_CAMERA_LIST,
} from './actions';
import { ZONES_MODULE } from '../../configs/moduleNames';
import {
  createLoadParameterReducer,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  loadingZones: false,
  zones: [],
  loadingPositionByCamera: false,
  positionByCameraList: [],
  loadingZonesByCamera: false,
  zonesByCameraList: [],
  loadingCreatePosition: false,
  loadingDeletePosition: false,
  loadingCreateZone: false,
  loadingDeleteZone: false,
};

const reducer = handleActions({
  ...createLoadParameterReducer(ZONES_MODULE + LOAD_LIST, 'zones', 'loadingZones', []),
  ...updateLoadParameterReducer(ZONES_MODULE + LOAD_POSITION_BY_CAMERA_LIST, 'positionByCameraList', 'loadingPositionByCamera', []),
  ...updateLoadParameterReducer(ZONES_MODULE + LOAD_ZONES_BY_CAMERA_LIST, 'zonesByCameraList', 'loadingZonesByCamera', []),
  ...createOperationStateReducer(ZONES_MODULE + CREATE_POSITION, 'loadingCreatePosition'),
  ...createOperationStateReducer(ZONES_MODULE + DELETE_POSITION, 'loadingDeletePosition'),
  ...createOperationStateReducer(ZONES_MODULE + CREATE_ZONE, 'loadingCreateZone'),
  ...createOperationStateReducer(ZONES_MODULE + DELETE_ZONE, 'loadingDeleteZone'),
}, initialState);

export default reducer;

export const getZonesData = createSelector(
  [state => state[ZONES_MODULE]],
  state => {
    const {
      loadingZones,
      zones,
      loadingPositionByCamera,
      positionByCameraList,
      loadingZonesByCamera,
      zonesByCameraList,
      loadingCreatePosition,
      loadingDeletePosition,
      loadingCreateZone,
      loadingDeleteZone,
    } = state;
    return {
      loadingZones,
      zones,
      loadingPositionByCamera,
      positionByCameraList,
      loadingZonesByCamera,
      zonesByCameraList,
      loadingCreatePosition,
      loadingDeletePosition,
      loadingCreateZone,
      loadingDeleteZone,
    };
  },
);
